
import Header from "../components/header";
import Sidebar from "../components/sidebar";
import AddStaff from "../components/addStaff";
import Footer from "../components/footer";

function AddStaffPage() {
  return (
    <div>
    <div className='wrapper'>
      <Header />
      <Sidebar /> 
      <AddStaff /> 
    </div>
    <Footer /> 
  </div>
  // <Login/>
  );
}
export default AddStaffPage;
